import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import DecimalInput from 'commons/DecimalInput';
import Text from 'commons/Text';

import useStyles from './styles';

const CollectorEditionUIView = ({
  editionNumber,
  onEditionNumberChange,
  editionVolume,
  onEditionVolumeChange,
  disabled,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Text
        className={classes.label}
        mt={16}
      >
        {t('editions')}
        <span className={classes.require}>*</span>
      </Text>

      <Stack
        direction="row"
        sx={{ mt: 1, alignItems: 'center' }}
      >
        <div className={classes.flexItem}>
          <Text
            className={classes.label}
            mb={4}
          >
            {t('edition_number')}
          </Text>

          <DecimalInput
            value={editionNumber}
            onChange={onEditionNumberChange}
            decimalInputStyle={classes.decimalInputStyle}
            inputProps={{
              type: 'text',
            }}
            disabled={disabled}
          />
        </div>

        <div className={classes.lineSeparate}>/</div>

        <div className={classes.flexItem}>
          <Text
            className={classes.label}
            mb={4}
          >
            {t('edition_volume')}
          </Text>

          <DecimalInput
            value={editionVolume}
            onChange={onEditionVolumeChange}
            decimalInputStyle={classes.decimalInputStyle}
            inputProps={{
              type: 'text',
            }}
            disabled={disabled}
          />
        </div>
      </Stack>
    </>
  );
};

export default CollectorEditionUIView;
